import { Button, TableItem } from 'components/atoms';
import ArtistDuplicatePopup from 'components/molecules/popup/artist-duplicate-popup/ArtistDuplicatePopup';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { FormikHelpers, useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { useCustomParamId } from 'hooks/useParamId';
import { t } from 'i18next';
import { PiNavigationArrow, PiUserCircleDashed } from 'react-icons/pi';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useGetArtistDuplicates,
  useUpdateArtistDuplicate,
} from 'services/artists/duplicates';
import {
  IArtistMutationForm,
  IUpdateArtistDuplicate,
} from 'services/artists/types';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const ArtistDuplicates = () => {
  const artistId = useCustomParamId('id');

  const { values }: IFormikContextType<IArtistMutationForm> =
    useFormikContext<IArtistMutationForm>();

  const artists = useGetArtistDuplicates(artistId);

  const update = useUpdateArtistDuplicate();

  const navigateToNewWindow = useNewWindowNavigate();

  const onDuplicateArtist = async (
    values: IUpdateArtistDuplicate,
    helpers: FormikHelpers<IUpdateArtistDuplicate>,
    actions: PopupActions | null
  ) =>
    await update.mutateAsync(values, {
      onSuccess: () => {
        helpers.resetForm();
        actions?.close();
        artists.refetch();
      },
      onError: error => onErrorShowAllErrorsToast(error),
    });

  return (
    <TopbarPage
      topbar={
        <TopBar
          hideBackButton
          topbarContent={
            <ArtistDuplicatePopup
              initialValues={{
                artistId: '',
                version: values.version ?? 0,
                originalArtistId: artistId,
              }}
              originalName={values.nickname}
              onSubmit={onDuplicateArtist}
              trigger={
                <Button>
                  <Button.Icon icon={<PiUserCircleDashed />} />
                  <Button.Text text={t('button.add')} />
                </Button>
              }
            />
          }
        />
      }>
      <Table
        id='artist-duplicates'
        data={{ nodes: artists.data ?? [] }}
        columns={[
          {
            label: t('input.label.artist'),
            renderCell: ({ nickname }) => (
              <TableItem>
                <TableItem.Text text={nickname} />
              </TableItem>
            ),
          },
          {
            label: '',
            renderCell: ({ id }) => (
              <TableItem justifyPosition='end'>
                <Button
                  isClear
                  onlyIcon
                  onClick={() => navigateToNewWindow(`artist/${id}`)}>
                  <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              </TableItem>
            ),
          },
        ]}
      />
    </TopbarPage>
  );
};

export default ArtistDuplicates;
